/* HURRICANE theme — assets/js/setcard.js + assets/js/pdp.js. Generated by _build/theme/pack.mjs from the static site's own JS. */
(function () {
'use strict';
var W = window, HRC = W.HRC;
if (!HRC || HRC.setCard) return;
var t = HRC.t || {};
function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
var PARTS = { 'car-body': ['car', 'shower'], 'car-home': ['car', 'home'], complete: ['car', 'home', 'shower'] };
var cap1 = function (s) { return String(s || '').replace(/^./, function (c) { return c.toUpperCase(); }); };
HRC.setCard = function (o) {
var Z = t.set || {}, id = o.id || 'sc' + Math.random().toString(36).slice(2, 7), gift = !!o.giftPath;
var byKind = {}; o.pieces.forEach(function (x) { byKind[x.kind] = x; });
var same = o.pieces.length > 1 && o.pieces.every(function (x) { return x.kind === 'car' || x.match === 'same'; });
var lead = Z['cardLead' + (same ? 'Same' : '') + (gift ? 'Gift' : '')] || '';
var ship = function (kind, b) { return b.buy && b.sum != null ? '<p class="scard__ship micro" data-ship="' + kind + '" data-extra="' + b.sum + '" data-ids="' + esc((b.ids || []).join(',')) + '" aria-live="polite"></p>' : ''; };
var item = function (x) {
return '<li class="setc__i" data-kind="' + esc(x.kind) + '"><a class="setc__img" href="' + esc(x.href) + '" tabindex="-1" aria-hidden="true">' + (x.img || '') + '</a>' +
'<p class="setc__n"><span class="setc__ok" aria-hidden="true">✓</span><a href="' + esc(x.href) + '">' + esc(x.name) + '</a></p>' + (x.sub ? '<p class="setc__k">' + esc(x.sub) + '</p>' : '') + '</li>';
};
var why = function (kinds) {
var P = Z.piece || {}, Y = Z.why || {}, miss = kinds.filter(function (k) { return byKind[k] && !byKind[k].sells; }).map(function (k) { return P[k]; }).filter(Boolean);
return miss.length === 1 ? cap1(HRC.fmt(Y.one, { a: miss[0] })) : miss.length > 1 ? cap1(HRC.fmt(Y.two, { a: miss[0], b: miss[1] })) : '';
};
var cards = [];
if (o.gift) {
var g = o.gift, gh = id + '-h' + cards.length;
cards.push('<li class="setc setc--gift" data-bundle="gift-box"><p class="setc__h" id="' + gh + '">' + esc(Z.giftTab) + '</p>' +
'<ul class="setc__items setc__items--1" role="list" aria-labelledby="' + gh + '">' + item({ kind: 'gift', name: g.name, href: g.href, img: g.img }) + '</ul>' +
'<p class="setc__d">' + esc(Z.giftLine) + '</p>' + (g.price ? '<p class="setc__t">' + esc(g.price) + '</p>' : '') + ship('item', g) + '<div class="setc__act">' + g.act + '</div></li>');
}
o.bundles.forEach(function (b) {
var kinds = PARTS[b.key] || [], hid = id + '-h' + cards.length, its = kinds.map(function (k) { return byKind[k]; }).filter(Boolean);
var w = b.buy ? '' : why(kinds);
cards.push('<li class="setc" data-bundle="' + esc(b.key) + '"><p class="setc__h" id="' + hid + '">' + esc((Z.bundle || {})[b.key] || b.key) + '</p>' +
'<ul class="setc__items setc__items--' + its.length + '" role="list" aria-labelledby="' + hid + '">' + its.map(item).join('') + '</ul>' +
(b.total ? '<p class="setc__t">' + esc(b.total) + '</p>' : '') + ship('set', b) + '<div class="setc__act">' + b.act.replace(/^<(a|button)\b/, '<$1 aria-describedby="' + hid + '"') + '</div>' +
(w ? '<p class="setc__why micro">' + esc(w) + '</p>' : '') + '</li>');
});
var pairs = o.pieces.filter(function (x) { return x.kind !== 'car' && x.line; }).map(function (x) { return '<li><span class="set__pn">' + esc(x.name) + '</span> <span class="set__s">' + esc(x.line) + '</span></li>'; }).join('');
return '<div class="scard" data-scard' + (gift ? ' data-scard-gift' : '') + '><p class="scard__lead">' + esc(lead) + '</p>' +
'<ul class="sets' + (cards.length === 1 ? ' sets--n1' : '') + '" role="list">' + cards.join('') + '</ul>' +
(cards.length > 1 ? '<p class="sets__more micro" aria-hidden="true">' + esc(Z.swipe) + ' →</p>' : '') +
(pairs ? '<ul class="scard__pairs" role="list">' + pairs + '</ul>' : '') + '</div>';
};
})();
;
(function () {
'use strict';
var W = window, d = document, HRC = W.HRC, $ = HRC.$, $$ = HRC.$$;
var pdp = $('[data-pdp]'), dataEl = $('#pdp-data');
if (!pdp || !dataEl) return;
var P; try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
var pid = P.product;
var cur = +pdp.getAttribute('data-variant') || 0;
var first = function (set) { return String(set || '').split(',')[0].trim().split(' ')[0]; };
var gal = $('[data-gallery]'), track = $('[data-gal-track]'), slides = $$('[data-gal-slide]'), thumbs = $$('[data-gal-to]');
var gi = 0, slidesOn = false;
function fill(sel) {
$$(sel + ' [data-srcset]', pdp).forEach(function (s) { s.setAttribute('srcset', s.getAttribute('data-srcset')); s.removeAttribute('data-srcset'); });
$$(sel + ' img[data-src]', pdp).forEach(function (i) { i.setAttribute('src', i.getAttribute('data-src')); i.removeAttribute('data-src'); });
}
function loadSlides() {
if (slidesOn) return; slidesOn = true;
fill('[data-gal-slide]'); fill('[data-gal-thumbs]');
}
HRC.afterPaint(function () { fill('[data-gal-thumbs]'); setTimeout(loadSlides, 2500); });
function go(i) {
if (i) loadSlides();
gi = Math.max(0, Math.min(slides.length - 1, i));
track.style.transform = 'translate3d(' + (-100 * gi) + '%,0,0)';
slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === gi ? 'false' : 'true'); });
thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === gi ? 'true' : 'false'); });
$$('.gal__dots i', gal).forEach(function (t, k) { t.classList.toggle('on', k === gi); });
var th = thumbs[gi]; if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) th.parentNode.scrollLeft = Math.max(0, th.offsetLeft - 24);
}
if (gal && track && slides.length > 1) {
go(0);
thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-gal-to')); HRC.track('gallery', { product: pid, to: gi }); }); });
var vp = $('.gal__vp', gal), x0 = 0, y0 = 0, dx = 0, drag = false, pid0 = null, w = 1;
vp.addEventListener('pointerdown', function (e) {
loadSlides();
if (e.pointerType === 'mouse' && e.button !== 0) return;
x0 = e.clientX; y0 = e.clientY; dx = 0; drag = false; pid0 = e.pointerId; w = vp.clientWidth || 1;
});
vp.addEventListener('pointermove', function (e) {
if (e.pointerId !== pid0) return;
var mx = e.clientX - x0, my = e.clientY - y0;
if (!drag) {
if (Math.abs(mx) < 8 || Math.abs(mx) < Math.abs(my)) return;
drag = true; track.classList.add('drag');
try { vp.setPointerCapture(e.pointerId); } catch (x) {}
}
dx = mx;
var edge = (gi === 0 && dx > 0) || (gi === slides.length - 1 && dx < 0) ? 0.35 : 1;
track.style.transform = 'translate3d(calc(' + (-100 * gi) + '% + ' + (dx * edge).toFixed(1) + 'px),0,0)';
});
function end(e) {
if (e.pointerId !== pid0) return;
pid0 = null;
if (!drag) return;
drag = false; track.classList.remove('drag');
if (Math.abs(dx) > w * 0.18) { go(gi + (dx < 0 ? 1 : -1)); HRC.hintUsed('swipe'); } else go(gi);
}
vp.addEventListener('pointerup', end); vp.addEventListener('pointercancel', end);
gal.addEventListener('focusin', loadSlides);
gal.addEventListener('dragstart', function (e) { e.preventDefault(); });   // a mouse drag swipes; it never drags the image
gal.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { go(gi + 1); e.preventDefault(); }
else if (e.key === 'ArrowLeft') { go(gi - 1); e.preventDefault(); }
});
}
function setPic(pic, set) {
if (!pic || !set) return;
var s = pic.querySelector('source'), img = pic.querySelector('img');
if (img.hasAttribute('data-src')) { // a slide still waiting for loadSlides(): update what it will load
if (s) s.setAttribute('data-srcset', set.avif);
img.setAttribute('data-srcset', set.webp); img.setAttribute('data-src', set.src);
return;
}
if (s) s.setAttribute('srcset', set.avif);
img.setAttribute('srcset', set.webp); img.setAttribute('src', set.src);
}
function carPic(pic, c, title) {
if (!pic) return;
var ss = pic.querySelectorAll('source'), img = pic.querySelector('img'), lazy = img.hasAttribute('data-src');
var vals = [c.da, c.dw, c.a];
for (var k = 0; k < ss.length && k < 3; k++) ss[k].setAttribute(lazy ? 'data-srcset' : 'srcset', vals[k]);
img.setAttribute(lazy ? 'data-src' : 'src', c.w);
var alt = img.getAttribute('alt') || ''; img.alt = title + alt.slice(alt.lastIndexOf(','));
}
function thumbOf(slide) { var k = slide ? slides.indexOf(slide) : -1; return k < 0 ? null : $('[data-gal-to="' + k + '"] picture', pdp); }
function thumbPic(pic, set) {
if (!pic || !set) return;
var s = pic.querySelector('source'), img = pic.querySelector('img'), lazy = img.hasAttribute('data-src');
if (s) s.setAttribute(lazy ? 'data-srcset' : 'srcset', first(set.avif));
img.setAttribute(lazy ? 'data-src' : 'src', first(set.webp));
}
function stillOf(V) { return { srcs: [V.img.avif], srcset: V.img.webp, src: V.img.src }; }
function preloadStills() { var m = $('[data-gal-main] picture', pdp); if (m) HRC.still.preload(m, P.variants.filter(function (V) { return V && V.img; }).map(stillOf)); }
if (!HRC.saveData && !HRC.slowNet) HRC.afterPaint(preloadStills);
$$('.sw__b[data-v]', pdp).forEach(function (b) { b.addEventListener('pointerdown', preloadStills, { once: true }); b.addEventListener('focus', preloadStills, { once: true }); });
function text(sel, v) { var el = $(sel, pdp) || $(sel); if (el) el.textContent = v; }
function item(V) { return [{ variantId: V.id, productId: P.productId, name: P.name, variant: P.single ? '' : V.name, price: P.price, qty: 1 }]; }
function icon(m) {
return '<svg class="ico ico--note" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ((P.icons || {})[m] || '') + '</svg>';
}
var scentBox = $('[data-pdp-scent]', pdp);
function scentText(V, instant) {
HRC.scentSwap(scentBox, function () {
text('[data-pdp-sname]', V.name);
var tg = $('[data-pdp-stag]', pdp); if (tg) { tg.textContent = V.tag || ''; tg.hidden = !V.tag; }
text('[data-pdp-line]', V.line);
text('[data-pdp-tags]', V.tags);
$$('[data-pdp-chips] .chip', pdp).forEach(function (c, k) {
var ic = $('.chip__ico', c), n = $('.chip__n', c);
if (ic && V.chipM) ic.innerHTML = icon(V.chipM[k]);
if (n) { n.textContent = V.chips[k] || ''; return; }
var key = c.querySelector('.chip__k'); c.textContent = ''; if (key) c.appendChild(key); c.appendChild(d.createTextNode(' ' + (V.chips[k] || '')));
});
}, instant);
}
var setSec = $('[data-set]'), setForm = setSec && $('[data-set-form]', setSec);
function setSync(i) {
if (!setSec) return;
var on = null;
$$('[data-set-v]', setSec).forEach(function (s) { var me = +s.getAttribute('data-set-v') === i; s.hidden = !me || s.hasAttribute('data-set-none'); if (me) on = s; });
if (!setForm) return;
setForm.hidden = !on || on.hasAttribute('data-set-none') || on.hasAttribute('data-set-buy');
var f = function (k, v) { var x = $('[data-set-field="' + k + '"]', setForm); if (x) x.value = v; };
if (on) { f('scent', on.getAttribute('data-set-scent') || ''); f('set', on.getAttribute('data-set-names') || ''); }
}
if (setSec) setSec.addEventListener('click', function (e) {
var n = e.target.closest('[data-set-notify]');
if (n && setForm) {
var x = $('[data-set-field="set"]', setForm); if (x) x.value = n.getAttribute('data-set-notify');
setForm.hidden = false;
var em = $('input[type="email"]', setForm);
setForm.scrollIntoView({ block: 'center', behavior: HRC.RM || HRC.paused ? 'auto' : 'smooth' });
if (em) setTimeout(function () { em.focus({ preventScroll: true }); }, HRC.RM ? 0 : 350);
HRC.track('set_notify_pick', { set: n.getAttribute('data-set-notify') });
return;
}
var a = e.target.closest('[data-set-add]'); if (!a) return;
e.preventDefault();
var its = a.getAttribute('data-set-add').split(',').map(function (s) { var q = s.split(':'); return { p: q[0], v: +q[1] || 0 }; });
HRC.bag.addSet(its.map(function (it) { return [it.p, it.v]; }), { source: 'set' }).catch(function () {});
});
var swRow = $('.pdp__buy .sw__row', pdp);
function swEdge() {
if (!swRow) return;
var max = swRow.scrollWidth - swRow.clientWidth, x = swRow.scrollLeft;
if (max <= 1) swRow.removeAttribute('data-edge'); else swRow.setAttribute('data-edge', x <= 1 ? 'end' : x >= max - 1 ? 'start' : 'both');
}
function swReveal(smooth) {
var b = swRow && $('.sw__b[aria-checked="true"]', swRow), max = swRow ? swRow.scrollWidth - swRow.clientWidth : 0;
if (!b || max <= 1) return;
var rr = swRow.getBoundingClientRect(), br = b.getBoundingClientRect(), dx = br.left < rr.left + 24 ? br.left - rr.left - 24 : br.right > rr.right - 24 ? br.right - rr.right + 24 : 0;
if (!dx) return;
var to = Math.max(0, Math.min(max, swRow.scrollLeft + dx));
try { swRow.scrollTo({ left: to, behavior: smooth && !(HRC.RM || HRC.paused) ? 'smooth' : 'instant' }); } catch (e) { swRow.scrollLeft = to; }
}
if (swRow) { swRow.addEventListener('scroll', swEdge, { passive: true }); W.addEventListener('resize', function () { swEdge(); swReveal(false); }, { passive: true }); }
function pick(i, how) {
var V = P.variants[i]; if (!V) return;
cur = i;
pdp.setAttribute('data-variant', i);
$$('.sw__b[data-v]', pdp).forEach(function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-v') === i ? 'true' : 'false'); });
swReveal(how !== 'init'); swEdge();
var title = P.single ? P.name : P.name + ' — ' + V.name;
text('[data-pdp-title]', title);
text('[data-pdp-promise]', V.promise || '');
scentText(V, how === 'init');
$$('[data-v-only]').forEach(function (el) { el.hidden = +el.getAttribute('data-v-only') !== i; });
$$('[data-v-not]').forEach(function (el) { el.hidden = +el.getAttribute('data-v-not') === i; });
setSync(i);
$$('[data-pdp-pyramid] dd', pdp).forEach(function (dd, k) { dd.textContent = V.pyr[k] || ''; });
$$('[data-pdp-cmp] .cmp__n').forEach(function (dd, k) {
dd.textContent = '';
(V.cmp[k] || []).forEach(function (n, j) {
var s = d.createElement('span'), t = d.createElement('span');
s.className = V.cmpM ? 'cmp__d cmp__d--ico' : 'cmp__d';
if (V.cmpM) s.innerHTML = icon((V.cmpM[k] || [])[j]);
t.textContent = n; s.appendChild(t); dd.appendChild(s);
});
});
var cc = $('[data-pdp-cmp-c]'); if (cc) cc.textContent = V.tags;
var prof = $('[data-pdp-prof]');
if (prof && V.prof) $$('.prof__r', prof).forEach(function (r) {
var n = V.prof[r.getAttribute('data-axis')] || 0;
$$('.prof__s i', r).forEach(function (seg, k) { seg.classList.toggle('on', k < n); });
r.setAttribute('aria-label', r.getAttribute('data-l') + ' ' + n + ' / 5');
});
if (V.otl) $$('[data-opens] .otl__p').forEach(function (li, k) {
var o = V.otl[k]; if (!o) return;
var ic = $('.otl__i', li), n = $('[data-otl-n]', li);
if (ic) ic.innerHTML = icon(o.m);
if (n) n.textContent = o.n;
});
var main = $('[data-gal-main] picture', pdp);
if (main) HRC.still.swap(main, stillOf(V), { alt: title, instant: how === 'init' });
if (V.inScale) { setPic($('[data-gal-inscale] picture', pdp), V.inScale); thumbPic(thumbOf($('[data-gal-inscale]', pdp)), V.inScale); }
if (V.inCar) { carPic($('[data-gal-incar] picture', pdp), V.inCar, title); thumbPic(thumbOf($('[data-gal-incar]', pdp)), { avif: V.inCar.a, webp: V.inCar.w }); }
if (V.inCar) carPic($('[data-smells-car] picture'), V.inCar, title);
var pk = $('[data-gal-pack]', pdp);
if (pk && V.pack) {
setPic($('picture', pk), V.pack);
var pi = $('img', pk); if (pi) pi.alt = title + (pi.alt.lastIndexOf(',') >= 0 ? pi.alt.slice(pi.alt.lastIndexOf(',')) : '');
thumbPic(thumbOf(pk), V.pack);
}
thumbPic($('[data-gal-to="0"] picture', pdp), V.img);
if (slides.length > 1) go(0);
$$('[data-other-v]').forEach(function (u) { u.hidden = +u.getAttribute('data-other-v') !== i; });
var pl = $('[data-sec="places"]'); if (pl) pl.hidden = !$('[data-other-v="' + i + '"]', pl);
sbarSync();
if (how !== 'init') {
try { var u = new URL(location.href); if (V.slug) { u.searchParams.set('scent', V.slug); u.searchParams.delete('variant'); } else { u.searchParams.set('variant', V.id); u.searchParams.delete('scent'); } history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
HRC.emit('variant-tried', { product: pid, variant: i });
}
HRC.track('view_item', { product: pid, value: P.price, items: item(V) });
}
$$('.sw__b[data-v]', pdp).forEach(function (b) {
b.addEventListener('click', function () { var i = +b.getAttribute('data-v'); if (i !== cur) pick(i, 'user'); });
});
var add = $('[data-pdp-add]', pdp);
if (add) add.addEventListener('click', function () { HRC.bag.add(pid, cur, { source: 'pdp' }); });
$$('[data-pick]').forEach(function (a) {
a.addEventListener('click', function (e) {
if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
e.preventDefault();
var i = +a.getAttribute('data-pick');
if (i !== cur) pick(i, 'user');
W.scrollTo({ top: 0, behavior: HRC.RM || HRC.paused ? 'auto' : 'smooth' });
});
});
$$('[data-other-add]').forEach(function (b) {
b.addEventListener('click', function () {
var q = b.getAttribute('data-other-add').split(':');
HRC.bag.add(q[0], +q[1] || 0, { source: 'other' });
});
});
var sbar = $('[data-sbar]'), cta = $('[data-pdp-cta]'), foot = $('footer');
var ctaGone = false, footIn = false, sheet = false, bagOn = d.body.classList.contains('has-bagbar');
function sbarSync() {
if (!sbar) return;
var V = P.variants[cur];
var vb = $('[data-sbar-v]', sbar); if (vb) vb.textContent = V.name;
var dot = $('[data-sbar-change]', sbar); if (dot) dot.style.setProperty('--c', V.swatch);
var im = $('[data-sbar-img] picture', sbar); setPic(im, V.img);
}
function sbarShow() {
if (!sbar) return;
var on = ctaGone && !footIn && !sheet;
sbar.classList.toggle('show', on);
sbar.classList.toggle('sbar--over', on && bagOn);
sbar.setAttribute('aria-hidden', on ? 'false' : 'true');
if (on) sbar.removeAttribute('inert'); else sbar.setAttribute('inert', '');
d.body.classList.toggle('has-sbar', on);
}
if (sbar && cta && 'IntersectionObserver' in W) {
sbar.setAttribute('inert', '');
HRC.onScroll(function () { var g = cta.getBoundingClientRect().bottom < 0; if (g !== ctaGone) { ctaGone = g; sbarShow(); } });
if (foot) new IntersectionObserver(function (es) { footIn = es[0].isIntersecting; sbarShow(); }).observe(foot);
HRC.on('sheet', function (open) { sheet = !!open; sbarShow(); });
HRC.on('bagbar', function (on) { bagOn = !!on; sbarShow(); });
$('[data-sbar-add]', sbar).addEventListener('click', function () { HRC.bag.add(pid, cur, { source: 'sticky' }); });
var ch = $('[data-sbar-change]', sbar);
if (ch) ch.addEventListener('click', function () { HRC.quick.open(pid, cur, { source: 'sticky', onPick: function (i) { if (i !== cur) pick(i, 'user'); } }); });
}
(function () {
var blocks = $$('[data-defer]');
if (!blocks.length) return;
function fillIn(el) {
$$('[data-srcset]', el).forEach(function (s) { s.setAttribute('srcset', s.getAttribute('data-srcset')); s.removeAttribute('data-srcset'); });
$$('img[data-src]', el).forEach(function (i) { i.setAttribute('src', i.getAttribute('data-src')); i.removeAttribute('data-src'); });
}
HRC.afterPaint(function () {
if (!('IntersectionObserver' in W)) { blocks.forEach(fillIn); return; }
var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fillIn(e.target); } }); }, { rootMargin: '900px 0px' });
blocks.forEach(function (b) { io.observe(b); });
});
})();
if (W.HRC_PDP_FIT) {
var fitT = 0, fitW = W.innerWidth;
W.addEventListener('resize', function () { if (W.innerWidth === fitW) return; fitW = W.innerWidth; clearTimeout(fitT); fitT = setTimeout(W.HRC_PDP_FIT, 120); }, { passive: true });
if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { W.HRC_PDP_FIT(); });
}
(function () {
var q; try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
var i = cur;
if (q) {
var id = q.get('variant'), sc = (q.get('scent') || '').toLowerCase();
P.variants.forEach(function (V, k) { if ((id && String(V.id) === id) || (sc && (V.slug === sc || V.name.toLowerCase() === sc))) i = k; });
}
pick(i, 'init');
})();
})();